import SearchResults from 'components/prizes/all-prizes-page/SearchResults';
import { useRouter } from 'next/router';

const PrizeSearchResults = () => {
  const router = useRouter();

  const tier = router.query?.tier;
  const category = router.query?.category;
  const term = router.query?.term;

  return <SearchResults term={Array.isArray(term) ? term[0] : term} />;
};

export default PrizeSearchResults;
